import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import { FAILURE_ALL_ROLES, REQUEST_ALL_ROLES, SUCCESS_ALL_ROLES } from './actions';

export function roleReducer(state: EntityCollectionState<any> = entityCollectionDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_ALL_ROLES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ALL_ROLES:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_ALL_ROLES:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
